import {ISelectedRegionEstimatedPrice} from "../../actions/fetch_selected_region_estimated_price";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";

export enum ParagraphType {
    TEXT,
    LIST
}

export enum TextType {
    TEXT,
    LINK
}

export type ILocationGenericParagraphSingleText =
    | string
    | {
          type: TextType.LINK;
          href: string;
          text: string;
      };

export interface ILocationGenericParagraphText {
    type: ParagraphType.TEXT;
    text: ILocationGenericParagraphSingleText | ILocationGenericParagraphSingleText[];
}

export interface ILocationGenericParagraphList {
    type: ParagraphType.LIST;
    text: string[];
}

export interface ILocationGenericSection {
    headline: string;
    paragraphs: (ILocationGenericParagraphText | ILocationGenericParagraphList)[];
}

export interface ILocationGenericSectionProps {
    region: ISelectedRegion;
    selectedRegionEstimatedPrices: ISelectedRegionEstimatedPrice[];
}
